/** Plan-IDs und Limits (aus business/03_pricing_packaging) */
/**
 * Sentinel für "keine CRM-Anzahl-Begrenzung" — alle bezahlten Tarife enthalten ALLE
 * CRM-Integrationen (D-02). Bewusst ein Sentinel statt eines Literals (4 oder 10):
 * ein Literal würde still wieder deckeln, sobald ein fünfter CrmProviderId dazukommt.
 */
export const ALL_CRM_INTEGRATIONS = Number.MAX_SAFE_INTEGER;
export const PLAN_LIMITS = {
    free: {
        capturesPerDay: 10,
        capturesPerMonth: null,
        integrations: 1,
        premiumFeatures: false,
    },
    starter: {
        capturesPerDay: null,
        capturesPerMonth: 1_000,
        integrations: ALL_CRM_INTEGRATIONS,
        premiumFeatures: false,
    },
    pro: {
        capturesPerDay: null,
        capturesPerMonth: null,
        integrations: ALL_CRM_INTEGRATIONS,
        premiumFeatures: true,
    },
    team: {
        capturesPerDay: null,
        capturesPerMonth: null,
        integrations: ALL_CRM_INTEGRATIONS,
        premiumFeatures: true,
    },
};
export const PLAN_PRICE_CENTS = {
    free: 0,
    starter: 2900, // 29 €
    pro: 4900, // 49 €
    team: 9900, // 99 € — Basis inkl. genau 1 Sitz; jeder weitere Sitz: TEAM_SEAT_PRICE_CENTS
};
/**
 * Jahrespreise als explizite Tabelle statt berechnetem Rabatt (D-03, D-08): die gelockten
 * Punkte sind psychologisch saubere Zahlen und nicht exakt 80 % von 12× Monatspreis.
 */
export const PLAN_PRICE_CENTS_ANNUAL = {
    free: 0,
    starter: 27600, // 276 €/Jahr = 23 €/Monat bei Jahreszahlung (−20,7 %)
    pro: 46800, // 468 €/Jahr = 39 €/Monat bei Jahreszahlung (−20,4 %)
    team: 94800, // 948 €/Jahr = 79 €/Monat bei Jahreszahlung (−20,2 %) — Basis inkl. 1 Sitz
};
/** Preis je zusätzlichem Team-Sitz, monatlich: 15 €/Sitz/Monat (D-01, D-05). */
export const TEAM_SEAT_PRICE_CENTS = 1500;
/** Preis je zusätzlichem Team-Sitz, jährlich: 144 €/Sitz/Jahr = 12 €/Monat-Äquivalent, −20 % (D-08). */
export const TEAM_SEAT_PRICE_CENTS_ANNUAL = 14400;
/** Feature flags by plan (architecture/10) */
export const FEATURE_FLAGS = {
    intentSignals: { plans: ["pro", "team"] },
    companyGraphLight: { plans: ["pro", "team"] },
    followUpReminders: { plans: ["pro", "team"] },
    sharedLeadMemory: { plans: ["team"] },
};
//# sourceMappingURL=plans.js.map